import React, { memo } from 'react';
import { Textfit } from 'react-textfit';

interface Props {
  text: string;
}

const FitTitle: React.FC<Props> = ({ text }) => {
  return (
    <Textfit mode="multi" max={12} min={8}>
      {text}
    </Textfit>
  );
};

export default memo(FitTitle);
